module.exports = __webpack_public_path__ + "static/media/refund-icon.24367459.svg";